import React from 'react';

function Snippets() {
  return (
    <div>
      <h1>Snippets page!</h1>
    </div>
  );
}

export default Snippets;
